import { fetchWrapper } from '@/_helpers';

const BASE_ROUTE = 'email/email-broadcast';

// Email Broadcast Drafts
const createDraft = (payload) => fetchWrapper.post(`${BASE_ROUTE}/drafts`, payload);

const getDrafts = ({ team, page = 1, limit = 20, sortBy = 'createdAt:desc' } = {}) => {
    const params = new URLSearchParams();
    if (team) params.set('team', team);
    params.set('page', page);
    params.set('limit', limit);
    params.set('sortBy', sortBy);
    return fetchWrapper.get(`${BASE_ROUTE}/drafts?${params.toString()}`);
};

const getDraftById = (draftId) => fetchWrapper.get(`${BASE_ROUTE}/drafts/${draftId}`);

const updateDraft = (draftId, payload) => fetchWrapper.patch(`${BASE_ROUTE}/drafts/${draftId}`, payload);

const deleteDraft = (draftId) => fetchWrapper.delete(`${BASE_ROUTE}/drafts/${draftId}`);

const createBroadcastFromDraft = (draftId) => fetchWrapper.post(`${BASE_ROUTE}/drafts/${draftId}/broadcast`);

// Email Broadcasts
const getBroadcasts = ({ team, status, page = 1, limit = 20, sortBy = 'createdAt:desc' } = {}) => {
    const params = new URLSearchParams();
    if (team) params.set('team', team);
    if (status) params.set('status', status);
    params.set('page', page);
    params.set('limit', limit);
    params.set('sortBy', sortBy);
    return fetchWrapper.get(`${BASE_ROUTE}/broadcasts?${params.toString()}`);
};

const getBroadcastById = (broadcastId) => fetchWrapper.get(`${BASE_ROUTE}/broadcasts/${broadcastId}`);

const getBroadcastRecipients = (broadcastId, { page = 1, limit = 50, sortBy = 'createdAt:asc' } = {}) => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    params.set('sortBy', sortBy);
    return fetchWrapper.get(`${BASE_ROUTE}/broadcasts/${broadcastId}/recipients?${params.toString()}`);
};

const startBroadcast = (broadcastId) => fetchWrapper.post(`${BASE_ROUTE}/broadcasts/${broadcastId}/start`);

const pauseBroadcast = (broadcastId) => fetchWrapper.post(`${BASE_ROUTE}/broadcasts/${broadcastId}/pause`);

const cancelBroadcast = (broadcastId) => fetchWrapper.post(`${BASE_ROUTE}/broadcasts/${broadcastId}/cancel`);

const resumeBroadcast = (broadcastId) => fetchWrapper.post(`${BASE_ROUTE}/broadcasts/${broadcastId}/resume`);

// Email Broadcasts Quota
const getQuotaStatus = (externalEmailAccountId) => fetchWrapper.get(`${BASE_ROUTE}/quota?externalEmailAccount=${externalEmailAccountId}`);

export const emailBroadcastService = {
    createDraft,
    getDrafts,
    getDraftById,
    updateDraft,
    deleteDraft,
    createBroadcastFromDraft,
    getBroadcasts,
    getBroadcastById,
    getBroadcastRecipients,
    startBroadcast,
    pauseBroadcast,
    cancelBroadcast,
    resumeBroadcast,
    getQuotaStatus,
};
